import {gql} from '@apollo/client';

// 历史页：需要总未读 + 三个 tab 分项未读，用于渲染三个 tab 的红点
export const GET_DSP_COMPLAINT_HISTORY_UNREAD_COUNT = gql`
    query GetDspComplaintHistoryUnreadCount($dspId: Long!, $warehouseId: Long!) {
        getDspComplaintHistoryUnreadCount(dspId: $dspId, warehouseId: $warehouseId) {
            appealApprovedUnread
            appealRejectedUnread
            acknowledgedUnread
            totalUnread
        }
    }
`;

// 列表页（NavBar 入口角标）：只需要总未读，单独走精简版查询，避免拉无用分项
export const GET_DSP_COMPLAINT_TOTAL_UNREAD_COUNT = gql`
    query GetDspComplaintTotalUnreadCount($dspId: Long!, $warehouseId: Long!) {
        getDspComplaintHistoryUnreadCount(dspId: $dspId, warehouseId: $warehouseId) {
            totalUnread
        }
    }
`;

export interface DspComplaintHistoryUnreadCount {
    appealApprovedUnread: number;
    appealRejectedUnread: number;
    acknowledgedUnread: number;
    totalUnread: number;
}

export interface GetDspComplaintHistoryUnreadCountResponse {
    getDspComplaintHistoryUnreadCount: DspComplaintHistoryUnreadCount;
}

export interface GetDspComplaintHistoryUnreadCountVariables {
    dspId: number;
    warehouseId: number;
}

export interface GetDspComplaintTotalUnreadCountResponse {
    getDspComplaintHistoryUnreadCount: Pick<DspComplaintHistoryUnreadCount, 'totalUnread'>;
}

export type GetDspComplaintTotalUnreadCountVariables = GetDspComplaintHistoryUnreadCountVariables;
